import React, { ReactElement, useEffect } from 'react';
import { Button, ButtonGroup, Col, Dropdown, Row } from 'react-bootstrap';
import { BiNote, BiPlus } from 'react-icons/all';
import { useNavigate } from 'react-router';
import { CelluleContact } from '../Utils/CelluleContact';
import { LinkContainer } from 'react-router-bootstrap';
import { CellProps } from 'react-table';
import { CentreServiceScolaire } from '../../../../../common/src/entities';
import { useDeleteEntite, useEntites } from '../../../Utils/api';
import { useAlertDialog } from '../../../Utils/dialogContext';
import PopoverSimple from '../../Common/PopoverSimple';
import EnteteDePage from '../Utils/EnteteDePage';
import TableSimple from '../Utils/TableSimple';
import { Colonne } from '../Utils/TypesTableSimple';
import { removeStopwords } from 'stopword';

// TODO: vérifier si c'est voulu la nom Activites ?
export default function CentreServiceScolaires(): ReactElement {
    useEffect(() => {
        document.title = 'Centre de service scolaire - Dashboard';
    }, []);

    const bsAlert = useAlertDialog();
    const centreServiceScolaires = useEntites(CentreServiceScolaire);
    const [deleteCentreServiceScolaireQuery] = useDeleteEntite(CentreServiceScolaire);
    const navigate = useNavigate();
    const colonnes: Colonne<CentreServiceScolaire>[] = [
        {
            Header: 'Nom',
            accessor: 'name',
            Cell: ({ row }: CellProps<CentreServiceScolaire>) => {
                let name = row.original.name;
                if (!name) return '';
                name = row.original.name.replace('Centre de services scolaire', 'CSS');

                return name;
            },
            sortType: (rowA, rowB) => {
                const phraseA = rowA.original.name.split(' ');
                const phraseB = rowB.original.name.split(' ');
                const nomA = removeStopwords(phraseA, [
                    'centre',
                    'de',
                    'services',
                    'scolaire',
                    'scolaires',
                    'de',
                    'la',
                    "l'",
                    'du',
                    'les',
                    'des',
                    'aux',
                    'au',
                ]);
                const nomB = removeStopwords(phraseB, [
                    'centre',
                    'de',
                    'services',
                    'scolaire',
                    'scolaires',
                    'de',
                    'la',
                    "l'",
                    'du',
                    'les',
                    'des',
                    'aux',
                    'au',
                ]);
                return nomA[0].localeCompare(nomB[0], 'fr-CA');
            },
        },
        {
            Header: 'Contact',
            accessor: 'contact_par_defaut',
            Cell: CelluleContact,
        },
        {
            Cell: function CelluleNotes({ value }: CellProps<CentreServiceScolaire>) {
                return value ? (
                    <PopoverSimple inList texte={value} titre="Notes">
                        <BiNote />
                    </PopoverSimple>
                ) : null;
            },
            Header: 'Notes',
            accessor: 'notes',
            disableSortBy: true,
        },
    ];

    const deleteCentreServiceScolaire = async (c: CentreServiceScolaire) => {
        try {
            await deleteCentreServiceScolaireQuery(c.id);
        } catch (error) {
            const { response } = error;
            if (response.status === 409) {
                bsAlert("D'autres entités dépendent de ce CSS, impossible de le supprimer", 'warning');
            } else {
                bsAlert(`Erreur dans la suppression du CSS: ${error.message}`, 'danger');
            }
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <EnteteDePage texte="Centre de Service Scolaire" cacherBoutonRetour />
                </Col>
                <Col xs="auto">
                    <ButtonGroup>
                        <LinkContainer to="new">
                            <Button size="sm" variant="outline-primary" className="d-flex align-items-center">
                                <BiPlus /> Ajouter un centre de Serv. Scol.
                            </Button>
                        </LinkContainer>
                    </ButtonGroup>
                </Col>
            </Row>
            <TableSimple
                colonnes={colonnes}
                resultat={centreServiceScolaires}
                lien="id"
                hover
                affichageMenu={(value: CentreServiceScolaire) => (
                    <>
                        <Dropdown.Item onClick={() => navigate(String(value.id))}>Modifier</Dropdown.Item>
                        <Dropdown.Item className="text-danger" onClick={() => deleteCentreServiceScolaire(value)}>
                            Supprimer
                        </Dropdown.Item>
                    </>
                )}
                etatInitial={{
                    sortBy: [
                        {
                            id: 'name',
                            desc: false,
                        },
                    ],
                }}
            />
        </>
    );
}
